export const filterSelectOption = (inputValue: string, option: string): boolean => {
  return option.toLowerCase().includes(inputValue.toLowerCase())
}